exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#maintenance-table[data-v-133dff4a] td{vertical-align:middle}.filter-panel[data-v-133dff4a]{overflow:hidden;max-height:0;transition:max-height .35s ease}.filter-panel-open[data-v-133dff4a]{max-height:1000px}.filter-panel-content[data-v-133dff4a]{padding-left:15px;padding-bottom:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-133dff4a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Maintenance.vue
// module id = 889
// module chunks = 0